export default {"src":"/_next/static/media/code-brackets.ce956705.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};